// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"2ea7f668","73":"72b73607","167":"05cac6a2","205":"f127bcbf","543":"aaf50755","787":"c5e073d6","823":"8b65ce5b","926":"bb3e7b17"}[chunkId] + ".chunk.js";
};